import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MobileDetectorProvider } from "../../providers/mobile-detector";
import { App, NavController, Events } from "ionic-angular";
import { SearchService } from "../../providers/search.service";

@Component({
  selector: 'imarkt-header',
  templateUrl: 'imarkt-header.html'
})
export class ImarktHeaderComponent {
  @Input() title: string = '';
  @Output() saveSearchFilter = new EventEmitter();

  text: string;
  isMobile: boolean = window.innerWidth < 768;
  searchTerm: string = '';
  isLoggedIn: boolean;
  activePage: string = '';

  constructor(private app: App, public navCtrl: NavController, private _mobileDetector: MobileDetectorProvider, private _searchService: SearchService, private events: Events) {
    this._mobileDetector.isMobile.subscribe((data) => {
      this.isMobile = data;
    });

    this._searchService.searchStore.subscribe(() => {
      this.searchTerm = this._searchService.getSearchTerm();
    });

    this.app.viewDidEnter.subscribe((e) => {
      this.activePage = e.name;
    });

    this.isLoggedIn = !!+localStorage.getItem('isLoggedIn');
  }

  openPage(page) {
    this.navCtrl.setRoot(page).then(canEnter => {
      if (!canEnter) {
        this.navCtrl.setRoot('login');
      }
    });
  }

  openHome() {
    this.navCtrl.setRoot('home');
  }

  onInput() {
    this._searchService.setSearchTerm(this.searchTerm);
  }

  onCancel() {
    this.searchTerm = '';
  }

  openSearchFilter() {
    if (!this.isLoggedIn) {
      this.navCtrl.setRoot('login');
    } else {
      if (this.activePage != 'HomePage') {
        this.navCtrl.setRoot('home').then(res => {
          this.events.publish('searchFilterClicked');
        }).catch(console.warn);
      } else {
        this.saveSearchFilter.emit(true);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/imarkt-header/imarkt-header.ts